import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import noneImage from '../assets/none-png-2.png'
import { Link } from 'react-router-dom'

const Container = styled.div`
    font-size:12px;
    a{
        color:inherit;
        text-decoration:none;
        font-size:inherit;
        font:inherit
    }
`

const Image = styled.div`
    height:70px;
    width:80px;
    margin:0 5px;
    background-size: cover;
    background-position: center center;
    border-radius: 4px;
    transition: 0.1s linear;
    background-image:url(${props => props.bgUrl});
    @media screen and (max-width:768px){
        width: 70px;
        height:80px;
        margin:0 2px;
        border-radius:2px;
    }
`

const ImageContainer = styled.div`
        margin-bottom: 5px;
        position: relative;
`

const Title = styled.span`
    font-weight:700;
    text-align:center;
    display: block;
    margin-bottom: 3px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    `
const Title1 = styled.span`
text-align:center;
display: block;
margin-bottom: 3px;
overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;
`
const CastProfile = ({ id, imgUrl, title, char }) => {
    return (
        <Container>
            <Link to={`/person/${id}/`}>
                <ImageContainer>
                    <Image bgUrl={imgUrl && imgUrl ? `https://image.tmdb.org/t/p/w500${imgUrl}` : noneImage} />
                </ImageContainer>
                <Title>{title && title.length > 10 ? title.substring(0, 10) + '...' : title}</Title>
                <Title1>{char && char.length > 10 ? char.substring(0, 10) + '...' : char}</Title1>
            </Link>
        </Container>)
}

CastProfile.propTypes = {
    id: PropTypes.number.isRequired,
    imgUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    rating: PropTypes.number,
    year: PropTypes.string,
    isMovie: PropTypes.bool
}

export default CastProfile